import {HttpResponse, HttpService} from "./http.service";
import {AuthorModel} from "../models/author.model";
import {CountryModel} from "../models/country.model";
import {ExternalLink} from "../models/external-link";
import {PreviousBook} from "../models/previous-book";
import {ManuscriptModel} from "../models/manuscript.model";
import {PublisherApplicationModel} from "../models/publisher/publisher-application.model";
import {PaginationModel} from "../models/pagination.model";

export const AuthorService = {

    async updateProfile(
        id: number,
        nickname: string,
        first_name: string,
        last_name: string,
        birthYear: number,
        residencePlace: string,
        country: CountryModel,
        phone: string,
        bio: string,
        externalLinks: ExternalLink[],
        previousBooks: PreviousBook[],
        prizes: {name: string}[]
    ): Promise<HttpResponse<AuthorModel>> {
        const data = {
            external_links: externalLinks.map(link => {
                if (link.url.search('http') !== 0) {
                    link.url = 'http://' + link.url;
                }
                link.social_likes = link.social_likes ? link.social_likes : 0;
                return link;
            }),
            previous_books: previousBooks.map(previousBook => {
                return {
                    id: previousBook.id || null,
                    isbn: previousBook.isbn,
                    name: previousBook.name,
                    publisher_bn: previousBook.publisher_bn,
                    json_bn: previousBook.json_bn
                }
            }),
            nickname,
            first_name: first_name,
            last_name: last_name,
            birth_year: birthYear || null,
            residence_place: residencePlace,
            country: country?.iso,
            phone,
            bio,
            author_prizes: prizes
        };

        const response: HttpResponse<AuthorModel> = await HttpService.patch(`author/${id}/`, data);
        return response;
    },
    async updateAvatar(
        file: File,
        id: number
    ) {
        const bodyFormData = new FormData();
        bodyFormData.set('photo', file);

        const response = await HttpService.patch(`author/${id}/files/`, bodyFormData);

        return response.status;
    },
    async getProfile(): Promise<AuthorModel> {
        const response: HttpResponse<AuthorModel> = await HttpService.get('author/me/');

        return response.data;
    },
    async getMyManuscripts(page: number = 0, perPage: number = -1): Promise<PaginationModel<ManuscriptModel[]>> {
        let offset = page * perPage;
        let limit = perPage;
        // &ordering=-created

        const response: HttpResponse<PaginationModel<ManuscriptModel[]>> = await HttpService.get(`author/manuscripts/?offset=${offset}&limit=${limit}&ordering=-created`);

        return response.data;
    },
    async getMyApplications(page: number = 0, perPage: number = -1): Promise<PaginationModel<PublisherApplicationModel[]>> {
        let offset = page * perPage;
        let limit = perPage;

        const response: HttpResponse<PaginationModel<PublisherApplicationModel[]>> = await HttpService.get(`author/applications/?offset=${offset}&limit=${limit}`);

        return response.data;
    }
}
